import { Spinner, SpinnerSize, Tab } from "@blueprintjs/core";
import { useApiEffect } from "nsitools-react";
import * as React from "react";
import { useHistory, useParams } from "react-router";

import { DocumentTemplateApi } from "../../../../api";
import { BackButton, PageBase, ProtectedTabs } from "../../../../components";
import { ERoutes } from "../../../../ERoutes";
import { useApiService, useTl } from "../../../../hooks";
import { ETLCodes } from "../../../../locales";
import { DocumentTemplateDetailPage } from "./DocumentTemplateDetailPage";

export interface IDocumentTemplateItemPageProps {}

export const DocumentTemplateItemPage: React.FunctionComponent<IDocumentTemplateItemPageProps> = (props) => {
  const { t } = useTl();
  const { id, tab, state = "edit" } = useParams<{ id: string; tab: string; state: string }>();
  const documentTemplateId = React.useMemo(() => +id, [id]);
  const history = useHistory();
  const documentTemplateApi = useApiService(DocumentTemplateApi);
  const [displayName, loading] = useApiEffect(
    () => documentTemplateApi.getDisplayName(documentTemplateId),
    [documentTemplateId],
  );

  return (
    <PageBase
      breadCrumbs={[
        { text: t(ETLCodes.DocumentTemplates), route: ERoutes.documentTemplate },
        {
          text: documentTemplateId > 0 ? loading ? <Spinner size={SpinnerSize.SMALL} /> : displayName : t(ETLCodes.New),
        },
      ]}
    >
      <ProtectedTabs
        id="DocumentTemplateTab"
        onChange={(newTabId) => history.push(`${ERoutes.documentTemplate}/${id}/${newTabId}/${state}`)}
        selectedTabId={tab}
        renderActiveTabPanelOnly
      >
        <BackButton backRoute={ERoutes.documentTemplate} />
        <Tab
          id="detail"
          title={t(ETLCodes.Detail)}
          panel={<DocumentTemplateDetailPage documentTemplateId={+id} editMode={state === "edit"} />}
        />
      </ProtectedTabs>
    </PageBase>
  );
};
